import { StoreFilter } from '@/components/StoreFilter';
import { StoreList } from '@/components/StoreList';
import { useClickAndCollect } from './useClickAndCollect';
import * as Styled from './ClickAndCollect.styled';

export const ClickAndCollect = () => {
  const { filter, setFilter, setLocation, stores } = useClickAndCollect();

  return (
    <Styled.Section>
      <StoreFilter filter={filter} setFilter={setFilter} />
      {stores.length > 0 ? (
        <StoreList setLocation={setLocation} stores={stores} />
      ) : null}
    </Styled.Section>
  );
};
